import { Component } from '@angular/core';
import { LocalStorageService } from 'src/app/features/shared/services/LocalStorage.service';

@Component({
  selector: 'system-notification',
  templateUrl: './system-notification.component.html',
  styleUrls: ['./system-notification.component.css']
})
export class SystemNotificationComponent {

  systemNotification: any;

  constructor(private localStorageService: LocalStorageService) {}

  ngOnInit(): void {
    if (this.localStorageService.getSystemNotification()) {
      this.systemNotification = JSON.parse(this.localStorageService.getSystemNotification());
    }
  }

  CloseNotification(){
    this.systemNotification = null;
  }
}
